import { render, staticRenderFns } from "./UploadProgress.vue?vue&type=template&id=2498d55d&scoped=true"
import script from "./UploadProgress.vue?vue&type=script&lang=js"
export * from "./UploadProgress.vue?vue&type=script&lang=js"
import style0 from "./UploadProgress.vue?vue&type=style&index=0&id=2498d55d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498d55d",
  null
  
)

export default component.exports